import { store } from '@/store';
import requireCustomerLogin from '../require-customer-login/require-customer-login';

/**
 * Reject rewards access if it's not enabled
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function rewardsAccess(to, from, next) {
  const allowRewards = store.getters.getConfiguration.rewardsEnabled;
  const isCustomer = store.getters['user/isCustomer'];

  /* If rewards isn't enabled, redirect to not found page
   */
  if (!isCustomer && allowRewards) {
    requireCustomerLogin(to, from, next);
  } else if (!allowRewards) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
}
